<!--
    This component is a wrapper around Vuetify's v-autocomplete component.
    It allows to be used the same way as a normal v-autocomplete, but also allows to
    use scoped slots for items, and provides an itemMissing prop to handle cases where
    the selected item is not in the items list.
-->
<template>
    <v-autocomplete
        v-bind="$attrs"
        v-on="$listeners"
        :items="computedItems"
        :value="value"
        :error-messages="errorMessages"
    >
        <!-- Dynamically make all slots available from v-autocomplete -->
        <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotProps">
            <slot :name="name" v-bind="slotProps"></slot>
        </template>

    </v-autocomplete>
</template>

<script>
export default {
    name: 'zoezi-autocomplete',
    inheritAttrs: false,
    props: {
        value: {
            type: [String, Number, Object],
            default: null,
        },
        items: Array,
        itemMissing: {
            type: [String, Function],
            default: null,
        },
    },

    computed: {
        computedItems() {
            if (!this.items) {
                return [];
            }

            return this.items.concat();
        },
        selectedItem() {
            if (!this.value) {
                return null;
            }

            return this.items.find(i => (i[this.$attrs['item-value'] || 'value'] == this.value));
        },
        itemIsMissing() {
            return this.value && !this.selectedItem;
        },
        errorMessages() {
            let errorMessages = [];
            if (this.$attrs['error-messages'] !== undefined) {
                errorMessages = this.$attrs['error-messages'];
            }

            // Handle itemMissing logic
            if (this.itemMissing && this.itemIsMissing) {
                let message;

                if (typeof this.itemMissing == 'function') {
                    message = this.itemMissing(this.value);
                } else if (typeof this.itemMissing == 'string') {
                    message = this.itemMissing;
                } else {
                    console.error('itemMissing must be a string or function');
                    return errorMessages;
                }

                errorMessages.push(this.$translate(message));
            }

            return errorMessages;
        },
    },
}
</script>
